import { XIcon } from "@phosphor-icons/react";
import React from "react";
import { Modal as ModalDaisy, type ModalProps } from "react-daisyui";
import { twMerge } from "tailwind-merge";

const ModalComp = React.forwardRef<HTMLDialogElement, ModalProps>(
  ({ children, className, ...props }, ref): JSX.Element => {
    const classes = twMerge("bg-white", className);

    return (
      <ModalDaisy {...props} className={classes} ref={ref}>
        {children}
      </ModalDaisy>
    );
  },
);

type ModalCloseProps = {
  className?: string;
  onClick: () => void;
};

const ModalClose = ({ className, onClick }: ModalCloseProps) => {
  const classes = twMerge("bg-white text-[24px] cursor-pointer", className);
  return <XIcon className={classes} onClick={onClick} />;
};

export const Modal = Object.assign(ModalComp, {
  Header: ModalDaisy.Header,
  Body: ModalDaisy.Body,
  Actions: ModalDaisy.Actions,
  Close: ModalClose,
});
